export default "__VITE_ASSET__DDjNd6tp__"